import { render, staticRenderFns } from "./CreateCategoryModal.vue?vue&type=template&id=e491bff2"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCategoryModal.vue?vue&type=style&index=0&id=e491bff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports